import { updates } from '@/mocks/home';

export default function UpdateFeed() {
  return (
    <section id="updates" className="border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="flex items-center gap-2">
          <span className="h-5 w-1 rounded-full bg-primary-500" />
          <span className="font-label text-sm tracking-[0.2em] text-primary-700">LIVE FEED</span>
        </div>
        <div className="mt-3 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">更新短讯</h2>
          <p className="text-sm text-foreground-600">入口恢复、新增域名、节点维护，每条变化都记录在案。</p>
        </div>

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {updates.map((u, i) => (
            <article
              key={u.id}
              className={`flex flex-col gap-2 px-4 py-4 transition-colors hover:bg-background-100/70 md:flex-row md:items-center md:gap-5 md:px-6 ${
                i !== updates.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <div className="flex shrink-0 items-center gap-3 md:w-44 md:flex-col md:items-start md:gap-1">
                <span className="font-label text-sm text-foreground-800">{u.time}</span>
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[12px] text-accent-900">{u.tag}</span>
              </div>
              <p className="flex-1 text-sm leading-relaxed text-foreground-700">{u.text}</p>
              <i className="ri-arrow-right-s-line hidden text-foreground-400 md:block" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}